<template>
<div class="reservation-block" 
    :class="{
        'reserved': [1,7].includes(block.type),
        'reserved-isuserreservation': block.isUserReservation,
        'reserved-paymentdelayed': block.paymentDelayed && adminMode,
        'reserved-cart': block.type === 7 && adminMode,
        'reserved-partlypaid': block.partlyPaid && adminMode,
        'disabled': block.type === 2,
    }"
    @click="openReservation"
    :style="`left: calc(var(--time-base-pixel) * ${ reservation.steps });
        width: calc(var(--time-base-pixel) * ${ reservation.lengthSteps });`">
        {{ $_formatDateTime($_dateFormat.DATETIME_HI, reservation.start) }}
        -
        {{ $_formatDateTime($_dateFormat.DATETIME_HI, reservation.end) }}
        
        <span v-if="adminMode && !reservation.isPlaceholder">
            ({{ blockInfo }})
        </span>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        reservation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
        }),
        block() {
            const { block } = this.reservation;
            
            return block || {};
        },
        blockInfo() {
            const { block } = this.reservation;

            if (block.type === 2) {
                return block.disableReason || block.info;
            }

            return block.info;
        },
    },
    methods: {
        openReservation() {
            const reservation = this.reservation;
            const { block } = reservation;

            if (!this.adminMode 
                || reservation.isPlaceholder 
                || block.type === 7) {
                return false;
            }
                        
            this.$store.dispatch('calendar/setEditReservation', { block, reservation });
        },
    }
}
</script>